export default __webpack_public_path__ + "static/media/plagewatch.595a177c.jpg";